import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link as RouterLink } from 'react-router-dom'
import T from '../../../translate/T'

import { logout, logon, setStatus as setStatusLogin } from '../../../modules/actions/Login'
import { openModal, closeModal } from '../../../modules/actions/Modais'

import Modal from '../../atoms/Modal'
import Modalv2 from '../../atoms-v2/Modal'
import { Container, Row, Hidden, Col } from '../../atoms/Grid'
import Link from '../../atoms/Link'
import Icon from '../../atoms/FontIcon'
import Button from '../../atoms/Button'
import Valign from '../../atoms/Valign'
import Logo from '../../atoms/Logo'
import Avatar from '../../atoms/Avatar'
import If from '../../atoms/If'
import FloatBox from '../../atoms/FloatBox'
import Font from '../../atoms/Font'
import Loading from '../../atoms/Loading'

import CompleteUserData from '../../container/CompleteUserData'



import Search from '../../container/Search'
import MyInscriptions from '../../container/MyInscriptions'

import UserNotifications from '../UserNotifications'
// import SignupForm from '../../forms/SignupForm'
// import LoginModal from '../../container/login'


import style from './style.css'

import AsyncComponent from '../../atoms/AsyncComponent'
const LoginModal = AsyncComponent(() => import('../../container/login'), (<Loading style={{padding:'60px'}} />))
const SignupModal = AsyncComponent(() => import('../../container/signup'), (<Loading style={{padding:'60px'}} />))


class Topbar extends Component {

  constructor(props) {
    super(props)
    
    this.state = {
      menuActive: false,
      logged: false,
      modal_search: false,
      modal_inscriptions: false,
      CompleteUserData: false,
    }
 
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.toggleFloatBox = this.toggleFloatBox.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
    // this.toggleMenuSM = this.toggleMenuSM.bind(this)
  }

  componentWillMount() {
    this.props.logon()

    T.handleUpdate(() => {
        this.forceUpdate()
    })
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.modais.modalOpened) {
      this.openModal(nextProps.modais.modalOpened)
    }
    
    if(nextProps.loginData.isLogged !== this.props.loginData.isLogged) {
      if(nextProps.loginData.isLogged) {
        
        this.closeModal('modal-login')
        this.closeModal('modal-signup')
        this.setState({
          logged: true,
          CompleteUserData: true
        })
      } else {
        this.setState({
          logged: false,
          CompleteUserData: false          
        }) 
      }
    }

  }

  closeModal(ref) {
    if(this.refs[ref])    
    this.refs[ref].hide()
  }

  openModal(ref) {
    if(this.refs[ref])
    this.refs[ref].show()
  }

  handleModalClose() {
    this.props.closeModal()
  }

  toggleFloatBox(evt, ref) {
    this.refs['floatBoxUser'].hide()
    this.refs['floatBoxNotification'].hide()
    this.refs[ref].toggle(evt)
  }

  toggleMenuSM() {
    var status = false
    if(!this.state.menuActive) {
      status = true
    }

    this.setState({
      menuActive: status
    })
  }

  LoginModalAsync = () => (
    <LoginModal handleBtnSignup={() => {
      this.closeModal('modal-login')
      this.openModal('modal-signup')
      }} />
  )

  SignupModalAsync = () => (
    <SignupModal handleBtnLogin={() => {
      this.closeModal('modal-signup')
      this.openModal('modal-login')
      }} />
  )

  handleInscriptions = () => {
    this.setState({
      modal_inscriptions: true
    })
    this.refs['floatBoxUser'].hide()
  }


  render() {
    // const hamburgerMenu = () => (
    //   <Hidden lg>
    //     <Link className={`${style.menuIcon} ${ (this.state.menuActive) ? style.active : '' }`} onClick={() => this.toggleMenuSM()}>
    //       <div className={style.bar}/>
    //       <div className={style.bar}/>
    //       <div className={style.bar}/>
    //     </Link>
    //   </Hidden>
    // )
    const notLogged = () => (
        <div className={style.topbarRight}>
          <div style={{float:"left", marginRight: '10px'}}>
            <Hidden sm>
              <div className={style.link} style={{width: '130px'}}>
                <Valign>
                  <Button style={{fontSize: '12px'}} color='link-orange' onClick={() => this.openModal('modal-signup')}>{T.text('register')}</Button>
                </Valign>
              </div>
            </Hidden>
          </div>

          <div className={style.link}>        
            <Valign>        
              <Button style={{
                width: '100px',
                height: '32px',
                textTransform: 'uppercase',
                padding: '0 20px',
                fontSize: '12px'
              }} color='grey-orange' onClick={() => this.openModal('modal-login')}>{T.text('login')}</Button>
            </Valign>
          </div>
          {/* <Hidden sm> */}
          <div className={style.icon}>          
            <Valign text='center'>
              <Link onClick={() => {
                this.setState({
                  modal_search: true
                })
              } }>
                <Icon size={20} name='search' />
              </Link>          
            </Valign>
          </div>
          
          <div className={style.icon}>          
            <Valign text='center'>
              <RouterLink to="/explore">
                <Icon color='#f50' size={26} name='compass' />
              </RouterLink>
            </Valign>
          </div>
        {/* </Hidden> */}

        
          
          

          {/* {hamburgerMenu()}         */}
        </div>
    )
    
    const userLogged = () => (
      <div className={style.topbarRight} style={{position: 'relative'}}>
        <div style={{float: 'left'}}>
          {/* <Hidden sm> */}
            <div className={style.icon}>             
              <Valign text='center'>
                <Link onClick={() => {
                    this.setState({
                      modal_search: true
                    })
                  } }>
                  <Icon size={20} name='search' />
                </Link>     
              </Valign>
            </div>
          
            <div className={style.icon}>
              <Valign text='center'>
                <RouterLink to="/explore">
                  <Icon size={26} color='#f50' name='compass' />
                </RouterLink>
              </Valign>
            </div>
          {/* </Hidden> */}
        </div>
      
        <div className={style.icon}>          
          <Valign text='center'>
            <Link onClick={(e) => {
                this.toggleFloatBox(e, 'floatBoxNotification')
              }}>
              <div className={style.notification}>
                <If test={this.props.notification.unread}>
                  <div className={style.notificationBullet}>
                      { this.props.notification.unread }
                  </div>
                </If>
                <Icon size={26} name='user-notification' />
              </div>
            </Link>          
          </Valign>
        </div>
        <div className={style.icon}>                    
          <Valign text='center'>
            <Link onClick={(e) => {
              this.toggleFloatBox(e, 'floatBoxUser')
            }}>     
              <Avatar img={this.props.loginData.user.avatar !== '' ? `${window.URL_ASSETS_BASE}${this.props.loginData.user.avatar}` :  ''} size='40' />
            </Link>
          </Valign>
        </div>

        {/* {hamburgerMenu()} */}
        
        <If test={this.props.loginData.isLogged}>
          <FloatBox
            ref='floatBoxNotification'
            arrowRight='53px'>
            <UserNotifications />
          </FloatBox>

          <FloatBox ref='floatBoxUser' arrowRight='11px'>
            <div className={style.floatBoxUser}>
                <div className={style.user}>
                  <Avatar style={{float:'left'}} size='72' img={this.props.loginData.user.avatar !== '' ? `${window.URL_ASSETS_BASE}${this.props.loginData.user.avatar}` :  ''} />
                  <div className={style.userName}>
                      <div className={style.text}>
                        <Font size='18' color='#545454' style={{fontWeight:'bold'}}>
                          {this.props.loginData.user.name}
                        </Font>
                      </div>
                      <a href={`${window.config.url_base_old}${this.props.loginData.user.url_token}`}>
                        <Button min color='grey'>{T.text('my_account')}</Button>
                      </a>
                  </div>
                </div>
                <ul className={style.links}>
                  <li>
                    <Link href={`${window.config.url_base_old}me/events`}>{T.text('my_events')}</Link>
                  </li>
                  <li>
                    <Link onClick={(e) => {
                      e.preventDefault()
                      this.handleInscriptions()
                    }}>{T.text('my_inscriptions')}</Link>
                  </li>
                  {/* <li>
                    <Link>{T.text('my_clubs')}</Link>
                  </li>
                  <li>
                    <Link>{T.text('my_challanges')}</Link>
                  </li> */}
                  <li>
                    <Link onClick={this.props.logout}>{T.text('exit')}</Link>
                  </li>
                </ul>

            </div>
            <div className={style.footerEvent}>
              <a href={`${window.config.url_base_old}create2`}>
                <Button color='orange'>{T.text('create_event')}</Button>
              </a>
            </div>
          </FloatBox>
        </If>

      </div>
    )




    return (
      <header>
        <CompleteUserData
            active={this.state.CompleteUserData}
            handleDone={() => {
              this.setState(state => ({
                CompleteUserData: false,
              })
            )}}
          />

        <div className={style.topbar}>
          <Container>
            <Row>
              <Col>
                <div className={style.logo}>
                  <Valign>
                    <RouterLink to='/'>
                      <Logo size='100px' />
                    </RouterLink>
                    {/* {this.props.loginData.language === 'pt-BR' ? (
                      <div onClick={() => {
                        this.props.changeLanguage('en-US')
                      }}>en-US</div>
                    ) : (
                      <div onClick={() => {
                        this.props.changeLanguage('pt-BR')
                      }}>pt-BR</div>
                    )} */}
                  </Valign>
                </div>

                <If test={this.props.loginData.logonStatus === 'done'}>                  
                    <If test={!this.props.loginData.isLogged}>
                      {notLogged()}                          
                    </If>
                    <If test={this.props.loginData.isLogged}>                    
                      {userLogged()}
                    </If>
                </If>
              </Col>
            </Row>
          </Container>
        </div>
        <div className={style.spacer} />

        <If test={!this.state.logged}>
          <Modal
            ref='modal-login'
            padding='0'
            width='800px'
            component={this.LoginModalAsync}
            handleClose={this.handleModalClose}
            />
        
          <Modal
            ref='modal-signup'
            padding='0'
            width='680px'
            component={this.SignupModalAsync}
            handleClose={this.handleModalClose}
          />
        </If>
        <If test={this.state.logged}>
          <Modalv2
            style={{ width: "700px" }}
          
            active={ this.state.modal_inscriptions }
            handleClose={ () => {
              this.setState({
                modal_inscriptions: false
              })
            }}
            loadContent={ this.state.modal_inscriptions }
            >
              <MyInscriptions />
            </Modalv2>
        </If>
        <Modalv2
          style={{ width: "1080px" }}
          active={ this.state.modal_search }
          handleClose={ () => {
            this.setState({
              modal_search: false
            })
          }}>
          <Search handleRouterLink={() => {
            this.setState({
              modal_search: false
            })
          }} />
        </Modalv2>

        <Hidden lg>
          <div className={`${style.menuFullPage} ${ (this.state.menuActive) ? style.active : '' }`}>
            <Container>
              <ul className={style.menuSM}>
                <li>
                  <Link>
                    <Font>Sobre o SPRINTA</Font>
                  </Link>
                </li>
                <li>
                  <Link>
                    <Font>Grupos</Font>
                  </Link>
                </li>
                <li>
                  <Link>
                    <Font>Eventos</Font>
                  </Link>
                </li>
                <li>
                  <Link>
                    <Font>Desafios</Font>
                  </Link>
                </li>
                <li>
                  <Link>
                    <Font>Fale conosco</Font>
                  </Link>
                </li>
              </ul>
              <div className={style.socialIcons}>
                <Link className={style.socialIcon}>
                  <Icon size={26} name='facebook-orange' />
                </Link>

                <Link className={style.socialIcon}>
                  <Icon size={26} name='instagram-orange' />
                </Link>
              </div>

            </Container>
          </div>
        </Hidden>
        

      </header>
    )
  }
}

const mapStateToProps = state => ({
  loginData: state.login,
  signup: state.signup,
  notification: state.userNotification,
  modais: state.modais
})
const mapDispatchToProps = dispatch => bindActionCreators({
  logout,
  logon,
  setStatusLogin,
  openModal,
  closeModal
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Topbar)



// WEBPACK FOOTER //
// ./src/components/organisms/Topbar/index.js